GP.views.PremiumListItem = Backbone.Marionette.ItemView.extend({
    initialize: function() {
        this.view_type = GP.sdata.my_user.view_type;
        this.my_duid   = GP.sdata.my_user.duid;
    },
    template: function(serialized_data) {
        return template('content-premium-grid-item', serialized_data);
    },
    tagName: 'li',
    attributes: function() {

    },
    templateHelpers: function() {
        var self = this;

        var helpers = {
            content_type_image: function() {
                return (this.content.type == 'IMAGE');
            },
            content_type_video: function() {
                return (this.content.type == 'VIDEO');
            },
            show_username: function() {
                return !!this.content.premium_search;
            },
            purchased: function() {
                return (this.content.duid == self.my_duid || this.content.purchased);
            },
            purchased_class: function() {
                return helpers.purchased.call(this) ? 'purchased' : 'not-purchased';
            },
            display_price_credits: function() {
                var price_credits = (parseInt(this.content.credits, 10) || 0);
                if (price_credits === 0) {
                    price_credits = (this.content.type == 'VIDEO') ? GP.Premium.conf.default_prices.video : GP.Premium.conf.default_prices.image;
                }
                return price_credits + ' credits';
            },
            format_video_length: function() {
                var vid_len = this.content.video_length, // float in seconds

                    minutes = Math.floor(vid_len / 60),
                    seconds = Math.floor(vid_len % 60),

                    min_formatted = minutes,
                    sec_formatted = seconds,

                    minutes_width = minutes.toString().length,
                    seconds_width = seconds.toString().length;

                if (minutes_width == 1) {
                    min_formatted = "0" + minutes;
                }
                if (seconds_width == 1) {
                    sec_formatted = "0" + seconds;
                }

                return min_formatted + ":" + sec_formatted;
            }
        };
        return helpers;
    },
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {};
        data = {
            content: this.model.toJSON()
        };
        data.view_type = this.view_type;

        return data;
    },
    className: 'content-media-item grid-item',
    ui: {

    },
    events: {
        'click a.modal-link.purchased':     'trigger_viewer',
        'click a.modal-link.not-purchased': 'trigger_purchase'
    },
    modelEvents: {
        'change:thumb': 'render',
    },
    onRender: function() {
        // if (this.view_type == 'grid') {
        //     this.$el.addClass('grid-item');
        // }
    },
    trigger_viewer: function() {
        // trigger modal to view
        GP.vent.trigger('Premium:viewer', this.model.toJSON(), this.$el);
    },
    trigger_purchase: function() {
        // trigger Premium:purchase which will check if user has access/purchased,
        // and if not, will ask if they want to purchase and either use credits if they have
        // enough, or trigger the add credits modal to buy credits
        GP.vent.trigger('Premium:purchase', this.model.toJSON(), this.$el);
    }
});

GP.views.PremiumList = Backbone.Marionette.CollectionView.extend({
    tagName: 'ul',
    className: 'premium-media-list list-unstyled',
    childView: GP.views.PremiumListItem,
    emptyView: GP.views.NoResultsItemView.extend({
        tagName: 'li',
        template: function() {
            return '<div>' + js_lang.no_results_premium + '</div>';
        }
    }),
    isEmpty: function(collection) {
        return (collection.length === 0 && window.location.pathname.indexOf('content/premium') != -1) ? true : false;
    }
});
